module.exports = __webpack_public_path__ + "static/img/solution-case.aae042f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-case.png
// module id = fjdJ
// module chunks = 1